/**
 * État de propagation d'une statistique vers data-roole-api et Algolia.
 *
 * Volontairement isolé dans un module sans dépendance (comme `updateStatus.ts`) :
 * il est importé à la fois par le code serveur et par le bundle admin, qui ne
 * peut embarquer ni `@sentry/node` ni le global `strapi`.
 */
export const SyncStatus = {
  Synced: 'Synced',
  Failed: 'Failed',
} as const;

export type SyncStatus = (typeof SyncStatus)[keyof typeof SyncStatus];
